import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X as CloseIcon } from 'lucide-react';
interface CookiePreferencesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (preferences: {
    necessary: boolean;
    analytics: boolean;
    marketing: boolean;
  }) => void;
  preferences: {
    necessary: boolean;
    analytics: boolean;
    marketing: boolean;
  };
}
export const CookiePreferencesModal = ({
  isOpen,
  onClose,
  onSave,
  preferences
}: CookiePreferencesModalProps) => {
  const [localPreferences, setLocalPreferences] = useState(preferences);
  const handleSave = () => {
    onSave(localPreferences);
    onClose();
  };
  return <AnimatePresence data-id="element-118">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-50 flex items-center justify-center" onClick={onClose} data-id="element-119">
          <div className="absolute inset-0 bg-[rgba(17,18,30,0.55)] backdrop-blur-[4px]" data-id="element-120" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.3
      }} className="relative w-[480px] bg-white/90 backdrop-blur-sm overflow-hidden p-8" style={{
        borderRadius: '16px',
        boxShadow: `
                0 24px 48px rgba(0,0,0,0.15),
                0 0 80px rgba(134, 121, 223, 0.2)
              `
      }} onClick={e => e.stopPropagation()} data-id="element-121">
            <button onClick={onClose} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close modal" data-id="element-122">
              <CloseIcon size={20} data-id="element-123" />
            </button>
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-124">
              Cookie Preferences
            </h2>
            <div className="space-y-6" data-id="element-125">
              <div className="flex items-start" data-id="element-126">
                <div className="flex items-center h-6" data-id="element-127">
                  <input id="necessary" type="checkbox" checked={localPreferences.necessary} disabled className="h-4 w-4 rounded border-gray-300 text-[#8679DF] focus:ring-[#8679DF] cursor-not-allowed opacity-60" data-id="element-128" />
                </div>
                <div className="ml-3" data-id="element-129">
                  <label htmlFor="necessary" className="font-medium text-gray-900" data-id="element-130">
                    Necessary
                  </label>
                  <p className="text-sm text-gray-500" data-id="element-131">
                    Required for the website to function properly. Cannot be
                    disabled.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-132">
                <div className="flex items-center h-6" data-id="element-133">
                  <input id="analytics" type="checkbox" checked={localPreferences.analytics} onChange={e => setLocalPreferences(prev => ({
                ...prev,
                analytics: e.target.checked
              }))} className="h-4 w-4 rounded border-gray-300 text-[#8679DF] focus:ring-[#8679DF]" data-id="element-134" />
                </div>
                <div className="ml-3" data-id="element-135">
                  <label htmlFor="analytics" className="font-medium text-gray-900" data-id="element-136">
                    Analytics
                  </label>
                  <p className="text-sm text-gray-500" data-id="element-137">
                    Help us improve by measuring how visitors interact with our
                    site.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-138">
                <div className="flex items-center h-6" data-id="element-139">
                  <input id="marketing" type="checkbox" checked={localPreferences.marketing} onChange={e => setLocalPreferences(prev => ({
                ...prev,
                marketing: e.target.checked
              }))} className="h-4 w-4 rounded border-gray-300 text-[#8679DF] focus:ring-[#8679DF]" data-id="element-140" />
                </div>
                <div className="ml-3" data-id="element-141">
                  <label htmlFor="marketing" className="font-medium text-gray-900" data-id="element-142">
                    Marketing
                  </label>
                  <p className="text-sm text-gray-500" data-id="element-143">
                    Allow us to personalize your experience and send you
                    relevant content.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-8 flex justify-end gap-4" data-id="element-144">
              <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900" data-id="element-145">
                Cancel
              </button>
              <button type="button" onClick={handleSave} className="bg-[#8679DF] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-[#7668CE] transition-colors" data-id="element-146">
                Save Preferences
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};